import BaseCtrl from 'edge/platform/base/BaseCtrl';
import PolicyLandingUtil from 'edge/gateway/util/policylanding/PolicyLandingUtil';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures'; // PSA

const fn = ($scope, $state, ActivityService, UserService, UserInfoService, AccountService, PolicyService) => {
    const ctrl = Object.create(BaseCtrl);
    $scope.isAgent = UserInfoService.isAgent();

    ctrl.init = () => {
        $scope.loadingComplete = false;
        $scope.activitiesTurnedOnPSA = ApplicationFeatures.getAllFeatures().disableActivities_PSA !== 'true'; // PSA
        $scope.gatewayEndorsementEnabled = ApplicationFeatures.getAllFeatures().gatewayendorsement === 'true'; // PSA
        $scope.gatewayCancelationEnabled_PSA = ApplicationFeatures.getAllFeatures().gatewayCancelation_PSA === 'true'; // PSA
        $scope.gatewayRenewalEnabled_PSA = ApplicationFeatures.getAllFeatures().gatewayRenewal_PSA === 'true'; // PSA

        if ($scope.isAgent) {
            $scope.loadingDashboardTiles = true;

            $scope.selectedProducerCode = {};

            if ($scope.activitiesTurnedOnPSA) {
                $scope.loadingActivities = true;
                getActivities().then((activities) => {
                    $scope.activities = activities;
                    $scope.loadingActivities = false;
                });
            }

            $scope.$on('dashboardTilesLoaded', () => {
                $scope.loadingDashboardTiles = false;
            });

            if(localStorage.getItem('tempUrl') != null && localStorage.getItem('setTimeOut') != null){
                $scope.tempUrl = localStorage.getItem('tempUrl');
                $scope.tempUrlTime = localStorage.getItem('setTimeOut');
                localStorage.removeItem('tempUrl');
                localStorage.removeItem('setTimeOut');
                if($scope.tempUrlTime != null && (new Date().getTime()-$scope.tempUrlTime) < 120000){
                    window.location.replace($scope.tempUrl);
                }
            }

        } else {
            $scope.loadingDashboardTiles = false;
            $scope.loadingActivities = false;
            $scope.loadingAccounts = true;

            getRecentlyViewedAccounts().then((accounts) => {
                $scope.loadingAccounts = false;
                $scope.recentlyVisitedAccounts = accounts.slice(0, 10).map((account) => mapAccount(account)) || [];
            });

            getRecentlyViewedPolicies().then((policies) => {
                $scope.recentlyVisitedPolicies = policies.slice(0, 10).map((policy) => mapPolicy(policy)) || [];
            });
        }
    };

    /* Scope Functions*/
    function getActivities() {
        return ActivityService.getActivitiesForUser();
    }

    function getRecentlyViewedAccounts() {
        return AccountService.getRecentlyViewedAccounts();
    }

    function getRecentlyViewedPolicies() {
        return PolicyService.getRecentlyViewedPolicies();
    }

    function mapAccount(account) {
        return {
            account: account.accountHolder,
            accountNumber: account.accountNumber,
            policies: account.policySummaries ? account.policySummaries.map((policySummary) => {
                return {
                    policyNumber: policySummary.policyNumber,
                    lineOfBusiness: policySummary.policyLines[0].lineOfBusinessName
                };
            }) : [],
            producerCodes: account.producerCodes,
            createdDate: account.accountCreatedDate,
            address: account.accountHolderAddress,
            openActivities: account.numberOfOpenActivities,
            isCommercial: account.isCommercialAccount,
            isPersonal: account.isPersonalAccount,
            createdByMe: account.createdByMe
        };
    }

    function mapPolicy(policy) {
        return {
            account: {
                accountNumber: policy.accountNumber
            },
            accountHolderName: policy.accountHolderName,
            policyNumber: policy.policyNumber,
            latestPeriod: {
                policyLines: policy.policyLines
            },
            policyLines: policy.policyLines,
            producerCodeOfRecord: policy.producerCodeOfRecord,
            producerCodeOfService: policy.producerCodeOfService,
            primaryInsuredName: policy.primaryInsuredName,
            effective: policy.effective,
            expiration: policy.expiration,
            totalPremium: policy.premium,
            displayStatus: policy.displayStatus,
            delinquent: policy.delinquent,
            canUserView: policy.canUserView,
            createdByMe: policy.createdByMe,
            product: policy.product
        };
    }

    $scope.getPolicyTypeIcon = (policyType) => {
        return PolicyLandingUtil.getPolicyTypeIcon(policyType);
    };

    ctrl.showNewQuoteButton = () => {
        const accountPermCheckDTO = {
            permEntityType: 'Account',
            permEntityID: null,
            permission: 'create',
            isCheckPermEntity: false
        };
        const submissionPermCheckDTO = {
            permEntityType: 'Submission',
            permEntityID: null,
            permission: 'create',
            isCheckPermEntity: false
        };

        const acctPermPromise = UserService.hasUserPermission(accountPermCheckDTO);
        acctPermPromise.then((createAcc) => {
            $scope.canCreateAccount = createAcc;
        });
        const subPermPromise = UserService.hasUserPermission(submissionPermCheckDTO);
        subPermPromise.then((createSub) => {
            $scope.canCreateSub = createSub;
        });
    };

    ctrl.showNewQuoteButton(); // Check new quote permissions

    $scope.$watchCollection('[loadingActivities, loadingDashboardTiles]', () => {
        $scope.loadingComplete = (!$scope.loadingActivities && !$scope.loadingDashboardTiles);
    });

    return ctrl.create($scope);
};

fn.$inject = ['$scope', '$state', 'ActivityService', 'UserService', 'UserInfoService', 'AccountService', 'PolicyService'];

export default fn;
